// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.webanalytics.RentalManagerUserPropertyWebAnalyticsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyWebAnalyticsWebApiHandler_get,
  RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias, WebAnalyticsWebResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

interface GetParams {
  includeLeases?: boolean;
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_Options = UseQueryOptions<
  WebAnalyticsWebResponseDto,
  unknown,
  WebAnalyticsWebResponseDto,
  readonly [string, GetParams]
>;

const RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_GetKey = (getParams: GetParams) =>
  [RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_Path, getParams] as const;

export const RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_queryOptions = (getParams: GetParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyWebAnalyticsWebApiHandler_get(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get listing web analytics data for web clients
 */
export const useRentalManagerUserPropertyWebAnalyticsWebApiHandler_get = (
  getParams: GetParams,
  options: Omit<RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserPropertyWebAnalyticsWebApiHandler_get.getKey =
  RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_GetKey;
